
import { CustomerKYC } from '../routes/customers/customer_kyc'
import { useParams } from 'react-router-dom';
import useFirestoreDoc from '../helpers/useFirestoreDoc';
import { Customer, DocType } from '../types';
import { doc } from 'firebase/firestore';
import { useFirestore } from '../helpers/firebaseContext';
import { useState } from 'react';

const KYCDetailsPage = ({ }) => {
    const { customerId, kycId } = useParams();
    const [metaTypes, setMetaTypes] = useState<DocType[]>([]);  //this is for CustomerKYC to set the metatypes of files that exist on the KYC.  That way, we can populate the Generate PDF form properly.

    const db = useFirestore();
    const customerFullDataDoc = doc(db, "customers", customerId as string);

    const { loading: customerLoading, data: customerFullData } = useFirestoreDoc<Customer>(customerFullDataDoc);

    if (!customerFullData && !customerLoading) {
        return <div>Customer not found</div>;
    }

    return (

        <CustomerKYC
            kycID={kycId as string}
            metaTypes={metaTypes}
            setMetaTypes={setMetaTypes}
            disableUpload={false}
            customerData={{ ...customerFullData, id: customerId } as Customer}
            showButton={true}
            showActiveLinks={false}
            showKycVersion={false}
            showGeneratePDF={false} />

    )
}

export default KYCDetailsPage